import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { SortDirectionApi } from 'api-typings/common/common';
import { DiscoverCollectionSortFieldApi } from 'api-typings/users/users';
import type { DiscoverCollectionsCollection } from './discover-collections.types';

export function discoverCollectionsBackend(): Backend<DiscoverCollectionsCollection> {
  return {
    defaultOrder: {
      field: 'lastUpdated',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => {
      const ownerIdParam = getQueryParamValue(query, 'ownerId');
      const collectionIds = ids || [];

      let sortField;
      let sortDirection;
      if (order) {
        switch (order[0].field) {
          case 'name':
            sortField = DiscoverCollectionSortFieldApi.COLLECTION_NAME;
            break;
          case 'lastUpdated':
            sortField = DiscoverCollectionSortFieldApi.COLLECTION_LAST_UPDATED;
            break;
          default:
            throw new Error('Unsupported order by field');
        }

        sortDirection =
          order[0].direction === OrderByDirection.ASC
            ? SortDirectionApi.ASC
            : SortDirectionApi.DESC;
      }

      if (ownerIdParam.length) {
        return {
          endpoint: `users/0.1/users/${ownerIdParam[0]}/discover_collections/`,
          params: {
            collection_type: getQueryParamValue(query, 'type')[0],
            sort_direction: sortDirection,
            sort_field: sortField,
          },
        };
      }

      if (collectionIds.length) {
        return {
          endpoint: `users/0.1/discover_collections`,
          params: {
            collection_ids: collectionIds,
          },
        };
      }

      throw new Error(
        'You cannot call the Discover Collections fetch endpoint without params',
      );
    },
    push: (_, discoverCollection) => ({
      endpoint: 'users/0.1/discover_collections',
      isGaf: false,
      payload: {
        name: discoverCollection.name,
        description: discoverCollection.description,
        collection_type: discoverCollection.type,
        is_private: discoverCollection.isPrivate,
      },
    }),
    set: undefined,
    update: (authUid, delta, document) => {
      if (delta.name === undefined) {
        throw new Error('Name is required');
      }

      return {
        endpoint: `users/0.1/discover_collections/${document.id}`,
        method: 'PUT',
        payload: {
          name: delta.name,
          description:
            delta.description === undefined
              ? document.description
              : delta.description,
          is_private: delta.isPrivate,
        },
      };
    },
    remove: (authUid, discoverCollectionId) => ({
      endpoint: `users/0.1/discover_collections/${discoverCollectionId}`,
      method: 'DELETE',
      payload: {},
    }),
  };
}
